module.exports = "/images/sa.svg?e43c13a8b504fe96f5d6099add5ebd22";